module.exports = __webpack_public_path__ + "img/2f_r_bajitofu@2x.bb2bac02.png";